import { getGenerateImagesCategoriesApiV1GenerationsOrgIdGenerateImagesCategoriesGet } from '@/common/api/client/sdk.gen'
import type { GenerateImageCategoriesListResponse } from '@/common/api/client/types.gen'
import type { SearchableSelectOption } from '@/common/ui/SearchableSelect'

export type GenerateImageCategory = GenerateImageCategoriesListResponse

export const fetchGenerateImageCategories = async (orgId: string): Promise<GenerateImageCategory[]> => {
    const res = await getGenerateImagesCategoriesApiV1GenerationsOrgIdGenerateImagesCategoriesGet({
        path: { org_id: orgId },
    })
    return res.data ?? []
}

const categoryToOption = (item: GenerateImageCategory): SearchableSelectOption | null => {
    const label = (item.category_name ?? '').trim()
    if (!item.category_id || !label) {
        return null
    }
    return { value: item.category_id, label }
}

export const mapCategoriesToOptions = (items: GenerateImageCategory[]): SearchableSelectOption[] =>
    items.map(categoryToOption).filter((item): item is SearchableSelectOption => item !== null)

/** Подсказки категорий для генерации: весь список грузится разом, поиск на клиенте. */
export const fetchProductCategoryOptions = async (orgId: string, q: string): Promise<SearchableSelectOption[]> => {
    const items = await fetchGenerateImageCategories(orgId)
    const options = mapCategoriesToOptions(items)
    const query = q.trim().toLowerCase()
    if (!query) {
        return options
    }
    return options.filter(o => o.label.toLowerCase().includes(query))
}
